export default () =>  {
  return null;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/crossfilter2/src/null.js
// module id = UHEa
// module chunks = 0